module.exports = __webpack_public_path__ + "static/6-bb2a9d786466b818f84d3562895fb712.jpg";